export function formatPhone(value: string | undefined, prefix = '0', spaces = false): string {
  if (!value) {
    return '';
  }

  if (spaces) {
    value = value.replace(/(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
  }
  return `${prefix}${value}`;
}
